import React, { useState } from "react";
import { ArrowRepeat, Trash } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";
const uuid = uuidv4();
const SortingGenerator = ({ openModal }) => {
  const [question, setQuestion] = useState("");
  const [choices, setChoices] = useState(["", "", "", ""]);
  const [dropContainers, setDropContainers] = useState([]);
  const [dragItems, setDragItems] = useState([]);
  const [setSelected] = useState(choices[0]);

  const [answerIndex, setAnswerIndex] = useState(0);
  const [correctMessageDE, setCorrectMessageDE] = useState("");
  const [wrongMessageDE, setWrongMessageDE] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      question,
      dragItems,
      dropContainers,
    };

    const result =
      `<div id="${uuid}" />` +
      "<p><SortingCards data={" +
      JSON.stringify(data) +
      "}" +
      "id=" +
      JSON.stringify(question) +
      "key=" +
      JSON.stringify(question) +
      "/></p> ";
    openModal(result);
  };

  const handleChoiceChange = (index, value) => {
    const updatedChoices = [...choices];
    updatedChoices[index] = value;
    setChoices(updatedChoices);
  };

  const handleOptionChange = (value) => {
    const index = choices.findIndex((item) => {
      return item === value;
    });
    setSelected(value);
    setAnswerIndex(index);
    // const option = event.target.value;
    //const optionIndex = event.target.selectedIndex;
    //setSelectedOption(option);
  };

  const addChoice = () => {
    setChoices([...choices, ""]);
    console.log(choices);
  };
  ////////////////////new
  const addDropContainer = () => {
    setDropContainers([...dropContainers, { id: "" }]);
    console.log(dropContainers);
  };
  const handleDropContainerChange = (index, value) => {
    const updatedDropContainers = [...dropContainers];
    updatedDropContainers[index].id = value;
    //  updatedDropContainers[index].text = value;
    //  updatedDropContainers[index].icon = "";

    setDropContainers(updatedDropContainers);
  };
  const deleteDropContainer = (id) => {
    setDropContainers([
      ...dropContainers.slice(0, id),
      ...dropContainers.slice(id + 1),
    ]);
  };
  const addDragItems = () => {
    setDragItems([...dragItems, { id: "", container: "" }]);
    console.log(dragItems);
  };
  const handleDragItemsChange = (index, value) => {
    const updatedDragItems = [...dragItems];
    updatedDragItems[index].id = value;
    // updatedDragItems[index].text = value;
    setDragItems(updatedDragItems);
  };

  const deleteDragItems = (id) => {
    setDragItems([...dragItems.slice(0, id), ...dragItems.slice(id + 1)]);
  };
  const handleChangeMatch = (e, index) => {
    console.log(e, index);
    const updatedDragItems = [...dragItems];
    updatedDragItems[index].container = e.target.value;
    setDragItems(updatedDragItems);
  };

  return (
    <>
      <div className="grid  m-auto p-2">
        <form
        //  onSubmit={handleSubmit}
        //     className=" mx-auto mt-6 p-6 bg-white rounded-lg shadow-md "
        >
          <div className="flex flex-col gap-6 ">
            <div className="mb-4">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="question"
              >
                Question
              </label>
              <input
                className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="question"
                type="text"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                placeholder="Write your question here."
              />
            </div>
            {/** Drop Containers  */}
            <div className="my-2  ">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="dropContainers"
              >
                Drop Containers
              </label>
              {dropContainers.map((dropContainer, index) => (
                <div className="mb-4   ">
                  <label
                    //className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-blue-500 before:border-blue-gray-200 peer-focus:before:!border-blue-500 after:border-blue-gray-200 peer-focus:after:!border-blue-500">
                    className="text-xs block text-gray-400 font-bold mb-2"
                  >
                    {"Drop Container " + index}
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      key={index}
                      value={dropContainer.id}
                      onChange={(e) =>
                        // handleChoiceChange(index, e.target.value)
                        handleDropContainerChange(index, e.target.value)
                      }
                      className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      placeholder=" "
                    />
                    <button
                      type="reset"
                      onClick={() => deleteDropContainer(index)}
                    >
                      <Trash className="text-red-500" size={20} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <button
              className=" btn btn-square min-w-40  m-auto "
              onClick={addDropContainer}
              type="reset"
            >
              Add Drop Container
            </button>
            {/** Drag Items */}
            <div className="my-2 ">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="dragItems"
              >
                Drag Items
              </label>
              {dragItems.map((dragItem, index) => (
                <div className="mb-4">
                  <label
                    //className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-blue-500 before:border-blue-gray-200 peer-focus:before:!border-blue-500 after:border-blue-gray-200 peer-focus:after:!border-blue-500">
                    className="text-xs block text-gray-400 font-bold mb-2"
                  >
                    {"Drag Item " + index}
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      key={index}
                      value={dragItem.id}
                      onChange={(e) =>
                        // handleChoiceChange(index, e.target.value)
                        handleDragItemsChange(index, e.target.value)
                      }
                      className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      placeholder=" "
                    />

                    <button type="reset" onClick={() => deleteDragItems(index)}>
                      <Trash className="text-red-500" size={20} />
                    </button>
                  </div>
                  <div className="flex my-2 items-center">
                    <label
                      className="text-xs block text-gray-400 font-bold  "
                      htmlFor={"select" + dragItem}
                    >
                      Select Drop Container
                    </label>
                    <div className="mb-4 "></div>

                    <select
                      key={"select" + index + dragItem}
                      name={"select" + index + dragItem}
                      id={"select" + index + dragItem}
                      className="border-2 mx-2 "
                      onChange={(e) => handleChangeMatch(e, index)}
                      value={dragItem.container}
                    >
                      <option value={""}>{}</option>
                      {dropContainers.map(
                        (dropContainer, dropContainerIndex) => (
                          <option
                            key={
                              "select option" + dropContainerIndex + dragItem
                            }
                            name={
                              "select option" + dropContainerIndex + dragItem
                            }
                            id={"select option" + dropContainerIndex + dragItem}
                            value={dropContainer.id}
                          >
                            {dropContainer.id}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="btn btn-square min-w-40  m-auto"
              onClick={addDragItems}
              type="reset"
            >
              Add Drag Item
            </button>

            <div className="flex flex-row m-auto">
              <button
                onClick={handleSubmit}
                id="submitButton"
                key="submitButton"
                type="submit"
                className=" btn btn-square min-w-40  m-auto "
              >
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default SortingGenerator;
